import { cn } from "@/lib/utils";
import { MentionV4 } from "@/types/MentionCard";
import { formatMentionTiming } from "@/utils";
import { AnimatedAudioLinesIcon } from "@components/ui/audio-lines";
import { useMediaSelector } from "media-chrome/react/media-store";
import { useMemo } from "react";

export default function MentionTimingDisplay({
  indicesMetadata,
}: {
  indicesMetadata: MentionV4["indices_metadata"];
}) {
  const mediaCurrentTime =
    useMediaSelector((state) => state.mediaCurrentTime) ?? 0;
  const mediaPaused = useMediaSelector((state) => state.mediaPaused);

  const isWithinMention = useMemo(() => {
    return (
      mediaCurrentTime >= indicesMetadata!.start_time &&
      mediaCurrentTime <= indicesMetadata!.end_time
    );
  }, [mediaCurrentTime, indicesMetadata]);

  const isPlaying = isWithinMention && !mediaPaused;

  return (
    <div
      className={cn(
        "flex items-center gap-1 pl-1.5 pr-2 py-px rounded-sm shadow-xs border transition",
        isPlaying
          ? "bg-primary text-white border-primary"
          : "bg-card border-border"
      )}
    >
      <AnimatedAudioLinesIcon isAnimating={isPlaying} size={14} />
      <p className="text-sm font-medium">
        {formatMentionTiming(indicesMetadata!.start_time)}
      </p>
    </div>
  );
}
